module.exports = __webpack_public_path__ + "img/25.f281d1d.jpg";